import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {useState} from 'react';

import {BLUE, GRAY_LIGHT} from 'ui-library/Colors';
import useSidebarDragState, {SidebarResizeSeparator} from 'ui-library/hooks/useSidebarDragState';
import Modal from 'ui-library/modals/Modal';

import WarehouseDiagramSidebar from './WarehouseDiagramSidebar';
import WarehouseDiagramWrapper from './WarehouseDiagramWrapper';

export interface WarehouseDiagramModalProps {
  schemaName: string;
  focusTableName: string;
  setDraftSQLQuery: (newDraftSQLQuery: string) => void;
  draftSQLQuery: string;
  onRequestClose: () => void;
}

export default function WarehouseDiagramModal(props: WarehouseDiagramModalProps): JSX.Element {
  const {dragHandleProps, isResizing, sidebarWidth, sidebarWrapperProps} = useSidebarDragState({
    sidebarSide: 'right',
  });
  const [modalSQLQuery, setModalSQLQuery] = useState(props.draftSQLQuery);

  return (
    <div
      className={classNames('warehouse-diagram-modal-wrapper', css(isResizing && styles.resizing))}
      {...sidebarWrapperProps}
    >
      <Modal
        fullWidth={true}
        fullHeight={true}
        closeableOnBackgroundClick={false}
        closeableOnEscapeKey={false}
        bodyPadded={false}
        onRequestClose={props.onRequestClose}
        title="Entity Relationship Diagram"
      >
        <div className={css(styles.diagramModalContentWrapper)}>
          <div className={css(styles.diagramContainer)}>
            <WarehouseDiagramWrapper schemaName={props.schemaName} focusTableName={props.focusTableName} />
          </div>
          <SidebarResizeSeparator isResizing={isResizing} dragHandleProps={dragHandleProps} />
          <div className={css(styles.sidebarContainer)} style={{width: `${sidebarWidth}px`}}>
            <WarehouseDiagramSidebar
              modalSQLQuery={modalSQLQuery}
              onModalSQLQueryChange={(newQuery: string): void => {
                props.setDraftSQLQuery(newQuery);
                setModalSQLQuery(newQuery);
              }}
              sidebarWidth={sidebarWidth}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}

const styles = StyleSheet.create({
  diagramModalContentWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    overflow: 'hidden',
  },
  diagramContainer: {
    flexGrow: 1,
    zIndex: 0,
  },
  sidebarContainer: {
    height: '100%',
    overflowY: 'hidden',
    background: 'white',
    zIndex: 1,
  },
  sidebarSeparator: {
    borderLeft: `4px solid ${GRAY_LIGHT}`,
    cursor: 'col-resize',
    zIndex: 1,
  },
  sidebarSeparatorActive: {
    borderLeftColor: BLUE,
  },
  resizing: {
    cursor: 'col-resize',
  },
});
